import type { ApiResponse, Program, ProgramListItem } from '../types';
import { getErrorMessage } from '../types';
import { authApi } from './auth';
import { API_BASE, fetchWithAdmin } from './fetchHelper';

/** Shared write helper — POST/DELETE with admin auth + 401 handling. */
async function writeJson<T>(method: 'POST' | 'DELETE', path: string, body?: unknown): Promise<T> {
  const token = authApi.getToken();
  if (!token) throw new Error('Not authenticated');
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(body !== undefined ? { 'Content-Type': 'application/json' } : {}),
    },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  if (res.status === 401) {
    authApi.logout();
    throw new Error('Session expired. Please login again.');
  }
  const data: ApiResponse<T> = await res.json();
  if (!res.ok || !data.success) {
    throw new Error(getErrorMessage(data.error) || `API error: ${res.status} ${res.statusText}`);
  }
  return data.data as T;
}

export const programsApi = {
  listPrograms: () =>
    fetchWithAdmin<{ programs: ProgramListItem[]; total: number }>('/programs'),
  saveProgram: (p: Partial<Program>) =>
    writeJson<Program>('POST', '/programs', p),
  deleteProgram: (id: string) =>
    writeJson<{ deleted: boolean }>('DELETE', `/programs/${id}`),
};
